<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'configList', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку справочников
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника глобальных настроек: </h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['paramCode']}}</label>
										<md-input type="text"
												  :readonly="form.id !== 'new'"
												  v-model="form['paramCode']"></md-input>
										<span class="md-error" v-if="!$v.form.paramCode.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item text-center fieldsep">
									<md-field :class="getValidationClass('paramValue')">
										<label>{{mapElementName['paramValue']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model.number="form['paramValue']"></md-input>
										<md-input type="text" v-else v-model="form['paramValue']"></md-input>
										<span class="md-error" v-if="!$v.form.paramValue.required">Обязательно для заполнения</span>
									</md-field>
								</div>

							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="selectedDataId">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import { saveItem, getItem, deleteItem } from '@/utils/dict-api'

    export default {
        mixins: [
            validationMixin,
        ],
        components: {},
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
                options: [],
                dictCode: this.$route.params.dictCode,
                dictionaryId: '',
                configListData: [],
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
                    id: 'new',
                    action: 'save',
                    paramCode: '',
                    order: 1,
                    paramValue: '',
                },
                mapElementName: {
                    'order': 'Порядок отображения',
                    'paramCode': 'Код',
                    'paramValue': 'Значение',
                },
            }
        },
        validations: {
            form: {
                paramCode: {
                    required,
                },
                paramValue: {
                    // required
                },
            },
        },
        watch: {},
        methods: {
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.form = data
            },
            getElementData: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('global').then(result => {
                        this.configListData = result
                        var that = this
                        this.configListData.forEach(function (item) {
                            if (item.paramCode == that.selectedDataId) {
                                that.form = {...item}
                            }
                        })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    saveItem('global', JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'configList', params: { dictCode: 'configList' } })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteItem('global', JSON.stringify(this.$route.params.data)).then(result => {
                        this.$router.push({ name: 'configList', params: { dictCode: 'configList' } })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
            }
        },
    }
</script>


<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
